import baseEvents from './../../base/config/baseEvents';

export default function FlightsHeaderController(
    $scope,
    $rootScope,
    $controller,
    flightsFactory,
    previousState,
) {
    'ngInject';

    $controller('FlightsHeaderBaseController', {
        $scope,
        flightsFactory,
        previousState,
    });

    const vm = this;
    const ROUNDTRIP = 'roundtrip';

    Object.assign(vm, {
        resetFilters,
        initDate,
    });

    function initDate() {
        if ($scope.tempParams.flightType === ROUNDTRIP) {
            return $scope.tempParams.TicketSearchSegments[1]._date;
        }
        return null;
    }

    function resetFilters() {
        $rootScope.$broadcast(baseEvents.CLEAR_FILTERS);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/flightsHeaderCtrl.js